// extracted by mini-css-extract-plugin
export default {"text":"Flavors_text__xtCFi"};